import axios from "axios";
import { defineStore } from "pinia";
import { authHeader } from "@/helpers/authservice/auth-header";
import { apiRequestsHelper } from "@/state/pinia/apiRequestHelper";

const sanitizePositiveInteger = (value, fallback) => {
    const parsed = parseInt(value, 10);
    if (Number.isFinite(parsed) && parsed > 0) {
        return parsed;
    }
    return fallback;
};

const sanitizeSortingKey = (value) => {
    if (!value) return null;
    return encodeURIComponent(value);
};

const sanitizeSortingDirection = (value) => {
    if (!value) return null;
    return value === "ASC" ? "ASC" : "DESC";
};

export const usePresenceAdminModule = defineStore("presenceAdminModule", {
    state: () => ({
        presence_endpoint: "/admin/presence",
        presence: [],
        presencePagesCount: 0,
        presenceDataTotal: 0,
    }),
    getters: {
        getPresence: (state) => state.presence,
        getPresencePagesCount: (state) => state.presencePagesCount,
        getPresenceDataTotal: (state) => state.presenceDataTotal,
    },
    actions: {
        setPresence(data) {
            this.presence = data;
        },
        setPresencePagesCount(count) {
            this.presencePagesCount = count;
        },
        setPresenceDataTotal(count) {
            this.presenceDataTotal = count;
        },
        httpGetPresencePaging(payload) {
            const currentPage = sanitizePositiveInteger(payload.currentPage, 1);
            const sortingKey = sanitizeSortingKey(payload.sortingKey) || "lastSeenAt";
            const sortingDirection = sanitizeSortingDirection(payload.sortingDirection) || "DESC";
            const endpoint = `${this.presence_endpoint}?page=${currentPage}&sortingKey=${sortingKey}&sortingDirection=${sortingDirection}`;
            return axios({
                method: "get",
                url: endpoint,
                headers: authHeader(),
            })
                .then((response) => {
                    if (response.status === 200) {
                        const payloadData = response.data?.payload || response.data;
                        if (payloadData?.content) {
                            this.setPresence(payloadData.content);
                            this.setPresencePagesCount(payloadData.totalPages || 0);
                            this.setPresenceDataTotal(payloadData.totalElements || 0);
                        } else if (Array.isArray(payloadData)) {
                            this.setPresence(payloadData);
                            this.setPresencePagesCount(1);
                            this.setPresenceDataTotal(payloadData.length);
                        }
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetPresencePaging");
                });
        },
    },
});
